import {
  BodyR,
  Button,
  HeadingRegular,
  TextField,
} from '@pensionbee/honeypot-ui';
import router from 'next/router';
import { useEffect, useState } from 'react';
import { useAuthContext } from '@/domains/auth/authContext';
import z from 'zod';
import LoadingScreen from '@/domains/shared/components/LoadingScreen';

export const emailSchema = z
  .string()
  .email({ message: 'Please enter a valid email' });

const ForgotPassword = () => {
  const [email, setEmail] = useState<string>('');
  const [error, setError] = useState<string | undefined>(undefined);
  const { resetPassword, isPending } = useAuthContext();
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    setLoading(isPending);
  }, [isPending]);

  if (loading) {
    return <LoadingScreen contained />;
  }

  const handleSubmit = async (event: React.FormEvent<HTMLFormElement>) => {
    event.preventDefault();
    const { result, err } = await resetPassword(email.toLowerCase());
    if (result === 'navigate') {
      router.push('forgot-password/email-sent');
    } else {
      setError(err);
    }
  };

  const handleEmailChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    const inputValue = e.target.value;
    setEmail(inputValue);
    setError(undefined);

    const validation = emailSchema.safeParse(inputValue);
    if (!validation.success) {
      setError(validation.error.issues[0].message);
    }
  };

  return (
    <form onSubmit={handleSubmit} noValidate>
      <div className="pb-28">
        <HeadingRegular as="h1">Forgotten password</HeadingRegular>
      </div>
      <div className="mb-[1.75rem]">
        <BodyR>
          Enter the email address associated with your PensionBee account and
          we&apos;ll send you instructions to reset your password.
        </BodyR>
      </div>
      <TextField
        label="Enter email address"
        name="email"
        required
        error={error}
        onChange={handleEmailChange}
        value={email}
      />
      <div className="flex flex-row justify-between pb-[1.25rem]">
        <Button
          className={`span-12 ${error && 'bg-background border-1'}`}
          type="submit"
          disabled={!email || !!error || loading}
        >
          {'Submit'}
        </Button>
      </div>
    </form>
  );
};

export default ForgotPassword;
